/*
 * https://www.algolia.com/doc/api-reference/widgets/menu-select/js/#widget-param-attribute
 */
// import { menuSelect } from "instantsearch.js/es/widgets";

// DEV: Switched this to the connectMenu so we could customize and make more accessible w/ aria labeling

import { connectMenu } from "instantsearch.js/es/connectors";

// Define the rendering logic
const customMenuSelect = (renderOptions, isFirstRender) => {

  const { items, refine, widgetParams, state } = renderOptions;
  let container;

  // Ensure widgetParams.container is a DOM element
  if (typeof widgetParams.container === 'string') {
    container = document.querySelector(widgetParams.container);
  } else {
    container = widgetParams.container;
  }

  if (!container) {
    console.error('Container not found:', widgetParams.container);
    return;
  }
  
  if (isFirstRender) {
    const select = document.createElement('select');
    select.setAttribute('aria-label', widgetParams.ariaLabel);
    select.addEventListener('change', (event) => {
      refine(event.target.value);
    });

    container.appendChild(select);
  }

  const select = container.querySelector('select');

  select.innerHTML = `
    <option value="">${widgetParams.defaultOption}</option>
    ${items.map(item => `<option value="${item.value}" ${item.isRefined ? 'selected' : ''}>${item.label}</option>`).join('')}
  `;
  
};

// Create the custom widget
const customMenuSelectWidget = (opts) => {
  return connectMenu(customMenuSelect)({
    container: opts.container,
    attribute: opts.attribute,
    defaultOption: opts.defaultOption,
    ariaLabel: opts.ariaLabel,
  });
};

// Instantiate and use the custom widgets

export const ttecSolutionsTypes = customMenuSelectWidget({
  container: document.querySelector('[data-ttecsolutions-types]'),
  attribute: 'Types',
  ariaLabel: 'Select Type',
  defaultOption: 'All Types'
})

export const ttecSolutionsIndustries = customMenuSelectWidget({
  container: document.querySelector('[data-ttecsolutions-industries]'),
  attribute: 'Industries',
  ariaLabel: 'Select Industry',
  defaultOption: 'All Industries'
})

export const ttecSolutionsTechnology = customMenuSelectWidget({
  container: document.querySelector('[data-ttecsolutions-technology]'),
  attribute: 'Technology',
  ariaLabel: 'Select Technology',
  defaultOption: 'All Technology'
})
